import { render } from "./collapsibleDiv.vue?vue&type=template&id=7cfdcffc&scoped=true"
import script from "./collapsibleDiv.vue?vue&type=script&lang=js"
export * from "./collapsibleDiv.vue?vue&type=script&lang=js"

import "./collapsibleDiv.vue?vue&type=style&index=0&id=7cfdcffc&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfdcffc"]])

export default __exports__